// extracted by mini-css-extract-plugin
export var Content = "RelatedPressItems-module--Content--1F-b5";
export var ContentDate = "RelatedPressItems-module--ContentDate--p0wd3";
export var ContentTitle = "RelatedPressItems-module--ContentTitle--LgJ0X";